import type React from 'react';

import type { ErrorHandlerProps } from 'src/app/pages/decisionMakerProfile/pageContext';

export const DecisionMakerProfileErrorHandler: React.FC<ErrorHandlerProps> = ({ context: { error } }) => {
	throw new Error(`Failed to retrieve data for DecisionMakerProfile page (error: ${error})`);
};
